import type { ToolbarCollectionState } from '../state';

export interface FieldsSourceProvider {
  setOnTable(toolbar: ToolbarCollectionState<any, any>): void;
}
